import { render, staticRenderFns } from "./FormEditClasses.vue?vue&type=template&id=78fe5e5e&scoped=true"
import script from "./FormEditClasses.vue?vue&type=script&lang=js"
export * from "./FormEditClasses.vue?vue&type=script&lang=js"
import style0 from "./FormEditClasses.vue?vue&type=style&index=0&id=78fe5e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fe5e5e",
  null
  
)

export default component.exports